import { render, staticRenderFns } from "./AccessMyWalletContainer.vue?vue&type=template&id=6a10c9e0&scoped=true&"
import script from "./AccessMyWalletContainer.vue?vue&type=script&lang=js&"
export * from "./AccessMyWalletContainer.vue?vue&type=script&lang=js&"
import style0 from "./AccessMyWalletContainer.vue?vue&type=style&index=0&id=6a10c9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10c9e0",
  null
  
)

export default component.exports